import { render, staticRenderFns } from "./Approvals.vue?vue&type=template&id=34c8f4aa&scoped=true&"
import script from "./Approvals.vue?vue&type=script&lang=js&"
export * from "./Approvals.vue?vue&type=script&lang=js&"
import style0 from "./Approvals.vue?vue&type=style&index=0&id=34c8f4aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c8f4aa",
  null
  
)

export default component.exports